export enum ProgramStatus {
  ToContinue = 'to-continue',
  Completed = 'completed',
}
